import {
  MensagemOrigem,
  MensagemFiltro,
} from "core/features/mensagens/typings";
import { BaseFiltroPaginate } from "core/resources/enums/paginate";
import { useCallback, useState } from "react";

function useFiltroMensagens(defaultFiltro?: Partial<MensagemFiltro>) {
  const [filtro, setFiltro] = useState<MensagemFiltro>({
    page: 1,
    limit: BaseFiltroPaginate.Limit,
    mensagensRespondidas: false,
    origem: MensagemOrigem.Recebida,
    ...(defaultFiltro ?? {}),
  });

  const onChangeFiltro = useCallback((newValues: Partial<MensagemFiltro>) => {
    setFiltro((prev: any) => ({ ...prev, ...newValues }));
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  };
}

export default useFiltroMensagens;
